import { State } from '../state';

export const orders: State = {
    url: 'orders',
} as const;

export const newOrder: State = {
    url: 'orders/new',
    parent: orders
} as const;

export const editOrder: State = {
    url: 'orders/edit',
    parent: orders
} as const;

export const ordersUnavailable: State = {
    url: 'orders/unavailable',
    parent: orders
} as const;
